import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ICONS from "../../../../../assets/Icons";
import { taxCompliantViewAll } from "../../../../../redux/features/accounts/taxAccount/taxAccountViewAll";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import globalText from "../../../../../utils/globalText";
import SingleOptionSelector from "../../../../_utils/AccountCreationComponents/SingleOptionSelector";
import CommonLayout from "../../../../_utils/CommonLayout";
import CategorySelector from "../../../../_utils/TransactionCommonComponents/CategorySelector";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";
import SourceDestinationAccountDetail from "../../../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";
import TaxAccountViewAllPopup from "../../../../Accounts/TaxAccount/TaxAccountViewAllPopup";

const TaxTransactionStepAccount = (props) => {
  const dispatch = useDispatch();
  const [IFSC, setIFSC] = useState(
    props?.txnPayLoad?.bankAccountIFSC
      ? props?.txnPayLoad?.bankAccountIFSC
      : "",
  );
  const [activeType, setActiveType] = useState("pan");
  const [havePANAssociate, setHavePANAssociate] = useState(0);
  const [haveBankAssociate, setHaveBankAssociate] = useState(0);
  const [panNumber, setPanNumber] = useState(
    props?.txnPayLoad?.pan ? props?.txnPayLoad?.pan : null,
  );
  const [accountNumber, setAccountNumber] = useState(
    props?.txnPayLoad?.bankAccountNo ? props?.txnPayLoad?.bankAccountNo : "",
  );
  const [taxAccountId, setTaxAccountId] = useState(
    props?.txnPayLoad?.taxAccountId ? props?.txnPayLoad?.taxAccountId : null,
  );

  const { beneLookData } = useSelector((state) => state.verify);
  const bankData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );

  const sectionField = props?.selectedCategory?.configuration?.data?.find(
    (field) =>
      field?.name?.toLowerCase() === "section" && field?.data_type === "list",
  );

  const isTds =
    props?.selectedCategory?.name?.toLowerCase() === "tds" &&
    props?.txnPayLoad?.categories?.toLowerCase()?.split(",")?.includes("tds");

  const shouldShowAssociatedAccounts =
    (haveBankAssociate > GlobalConfiguration?.lengthCheckZero ||
      havePANAssociate > GlobalConfiguration?.lengthCheckZero) &&
    accountNumber &&
    IFSC;

  const formatCategory = (text) => {
    if (!text) return "";

    return text
      .replaceAll("_", " ")
      .toLowerCase()
      .split(" ")
      .map((word) =>
        ["tds", "gst"].includes(word)
          ? word.toUpperCase()
          : word.charAt(0).toUpperCase() + word.slice(1),
      )
      .join(" ");
  };

  const handleCloseModal = () => {
    props?.setIsModalOpen(false);
  };

  const handleOwnerSelection = (
    name,
    acc,
    ifsc,
    logo,
    ownerId,
    balance,
    lastFetched,
  ) => {
    props?.setTxnPayLoad((prev) => ({
      ...prev,
      ownerId,
      ownerAccountName: name,
      ownerBankAccountNo: acc,
      ownerBankIFSC: ifsc,
      ownerBankLogo: logo,
      ownerBankBalance: balance,
      ownerLastUpdated: lastFetched,
      settleType: "NEFT",
    }));
  };

  const handleAccountSelection = (
    accountName,
    accountNumber,
    ifsc,
    bankLogo,
    category,
    panNo,
    taxAccountId,
    labels,
    typeOfAccount,
    taxSection,
  ) => {
    setAccountNumber(accountNumber);
    setIFSC(ifsc);

    setPanNumber(panNo);
    const normalizedType = typeOfAccount?.toLowerCase();

    const categoriesArray = category
      ? category.split(",").map((c) => c.trim().toLowerCase())
      : [];

    let autoSelectedCategory = null;

    if (categoriesArray.includes(normalizedType)) {
      autoSelectedCategory = props?.categories?.find(
        (cat) => cat.name?.toLowerCase() === normalizedType,
      );
    }

    if (
      normalizedType === "tds" &&
      categoriesArray.includes("tds") &&
      taxSection?.section_name
    ) {
      props?.setTxnPayLoad((prev) => ({
        ...prev,
        tax_section: taxSection,
      }));
    } else {
      props?.setTxnPayLoad((prev) => ({
        ...prev,
        tax_section: null,
      }));
    }

    props?.setTxnPayLoad((prev) => ({
      ...prev,
      taxAccountBankName: accountName,
      taxAccountId,
      bankAccountIFSC: ifsc,
      bankAccountNo: accountNumber,
      bankLogo,
      pan: panNo,
      labels,
      categories: category,
      selectedCategory: autoSelectedCategory,
    }));

    if (autoSelectedCategory) {
      props?.setSelectedCategory(autoSelectedCategory);
    }

    props?.setHasUserSelectedAccount(true);
    handleCloseModal();
  };

  const handleCategorySelect = (category) => {
    const categoryData = props?.categories.find(
      (cat) =>
        cat.name?.trim().toLowerCase() === category?.trim().toLowerCase(),
    );

    if (!categoryData || categoryData?.active !== "Y") {
      props?.setSelectedCategory(null);

      props?.setTxnPayLoad({
        ...props?.txnPayLoad,
        selectedCategory: null,
        mergeCategory: null,
      });

      return;
    }

    if (props?.selectedCategory?.name === category) return;

    props?.handleCategorySelect(categoryData);
    props?.setTxnPayLoad({
      ...props?.txnPayLoad,
      selectedCategory: categoryData,
      mergeCategory: null,
    });
    props?.setAdditionalData({});
    props?.setSelectedValue({ from: "Select", to: "Select" });
    props?.setStartDate({});
    props?.setEndDate({});
    props?.setStartDateCal({});
    props?.setHyperLink({});
    props?.setPreviewImages({});
    props?.setUploadedFiles({});
    props?.setTimeData({});
    props?.setQuantities({});
    props?.setSelectedValueMonth({});
  };

  useEffect(() => {
    if (props?.associateModalOpen) {
      document.querySelector("body").style.overflow = "hidden";
    } else {
      document.querySelector("body").style.overflow = "auto";
    }
  }, [props?.associateModalOpen]);

  useEffect(() => {
    setHaveBankAssociate(bankData?.total_count || 0);
    setHavePANAssociate(beneLookData?.total_count || 0);
  }, [beneLookData, bankData, dispatch]);

  useEffect(() => {
    if (!props?.txnPayLoad?.pan && !props?.txnPayLoad?.bankAccountNo) return;

    const fetchAssociateCount = async () => {
      try {
        if (props?.txnPayLoad?.pan) {
          const panRes = await dispatch(
            taxCompliantViewAll({
              page_no: 1,
              page_size: 1,
              pan: props.txnPayLoad.pan.toUpperCase(),
            }),
          );
          setHavePANAssociate(panRes?.payload?.total_count || 0);
        }

        if (
          props?.txnPayLoad?.bankAccountNo &&
          props?.txnPayLoad?.bankAccountIFSC
        ) {
          const bankRes = await dispatch(
            taxCompliantViewAll({
              page_no: 1,
              page_size: 1,
              bank_account_no: props.txnPayLoad.bankAccountNo,
              ifsc: props.txnPayLoad.bankAccountIFSC.toUpperCase(),
            }),
          );
          setHaveBankAssociate(bankRes?.payload?.total_count || 0);
        }
      } catch (e) {
        console.error("Associate count fetch failed", e);
      }
    };

    fetchAssociateCount();
  }, [
    props?.txnPayLoad?.pan,
    props?.txnPayLoad?.bankAccountNo,
    props?.txnPayLoad?.bankAccountIFSC,
  ]);

  return (
    <>
      <div
        className={`w-width-full flex flex-col Qlg:px-padding-base px-padding-md gap-gap-md Qsmd:py-padding-md pt-padding-md max-w-tab-width-normal mx-auto`}
      >
        <CommonLayout>
          <div className="w-width-full  lg:max-w-[var(--create-box-width)]">
            <SourceDestinationAccountDetail
              type="source"
              modalOpen={props?.openOwner}
              setModalOpen={props?.setOpenOwner}
              txnPayLoad={props?.txnPayLoad}
              setTxnPayLoad={props?.setTxnPayLoad}
              handleOnAccountSelection={handleOwnerSelection}
            />
          </div>

          <div
            className={`w-width-full lg:max-w-[var(--create-box-width)] ${
              !props?.txnPayLoad?.ownerBankAccountNo
                ? "opacity-light-opacity pointer-events-none"
                : "opacity-base-opacity"
            }`}
          >
            <TaxAccountViewAllPopup
              type="destination"
              flow="beneficiary"
              modalOpen={props?.isModalOpen}
              setModalOpen={props?.setIsModalOpen}
              txnPayLoad={props?.txnPayLoad}
              setTxnPayLoad={props?.setTxnPayLoad}
              shouldShowAssociatedAccounts={shouldShowAssociatedAccounts}
              handleOnAccountSelection={handleAccountSelection}
              setActiveType={setActiveType}
            />
          </div>

          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <ConfidentialCard
              icon={ICONS.CONFIDENTIAL_TRANSACTION}
              title={globalText?.CREATE_AS_CONFIDENTIAL}
              note={globalText?.CONFIDENTIAL_TRANSACTION_NOTE}
              toggleState={props?.isConfidential}
              onToggle={() => props?.setIsConfidential(!props?.isConfidential)}
            />
          </div>

          <div className="w-width-full lg:max-w-[var(--create-box-width)] pb-padding-md">
            <CategorySelector
              header={"Tax type"}
              headerNote={
                "This is fetched from selected tax account and can’t be changed."
              }
              beneAccountId={taxAccountId}
              category={
                props?.txnPayLoad?.categories
                  ? props.txnPayLoad.categories
                      .split(",")
                      .map((c) => formatCategory(c))
                  : []
              }
              selectedCategory={
                props?.selectedCategory
                  ? {
                      ...props.selectedCategory,
                      name: formatCategory(props.selectedCategory.name),
                      description:
                        props?.selectedCategory?.description ||
                        "No description available",
                    }
                  : null
              }
              handleCategorySelect={handleCategorySelect}
              handleUnassignNavigate={false}
              previewMode={false}
              enableSearch={false}
              showUnassignCTA={false}
              disableCategories={true}
              hideSubHeader={true}
              shouldHideCheckbox={true}
            />

            {isTds && sectionField && (
              <div className="w-width-full lg:max-w-[var(--create-box-width)] mt-margin-md">
                <SingleOptionSelector
                  title="Tax section"
                  selectedOption={
                    props?.txnPayLoad?.tax_section
                      ? {
                          name: props.txnPayLoad.tax_section.section_name,
                        }
                      : null
                  }
                  metaMap={{
                    [props?.txnPayLoad?.tax_section?.section_name?.toLowerCase()]:
                      {
                        description:
                          props?.txnPayLoad?.tax_section?.description,
                      },
                  }}
                  showIcon={false}
                  isSectionType={true}
                  isPrefilled={true}
                  type="tax_txn"
                  options={[
                    {
                      name: props?.txnPayLoad?.tax_section?.section_name,
                    },
                  ]}
                  shouldHideCheckbox={true}
                />
              </div>
            )}
          </div>
        </CommonLayout>
        <div className="h-mobile-create-header w-width-full Qmd:hidden block mt-margin-md"></div>
      </div>
    </>
  );
};

export default TaxTransactionStepAccount;
